import React from 'react';
import { GelRowLayout, GelColumnLayout } from '@tal-gel/components';
import { get, has } from 'lodash';
import { formatDateTime } from '../Shared/Text';
import { boldLabel, defaultH3Text } from '../Shared/Styles';

export default function InsuredParty(props) {
    const policyLife = props.insuredParty;

    return (
        <GelRowLayout>
            <GelRowLayout gutter="medium">
                <h3 style={defaultH3Text} data-testid="insuredPartyLabel">Insured Party</h3>
            </GelRowLayout>

            <GelRowLayout gutter="medium">
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="2/3 1/3">
                            <div style={boldLabel}>Name:</div>
                            <div style={boldLabel}>Date of Birth:</div>
                        </GelColumnLayout>
                    </GelRowLayout>

                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/4 1/4 2/4">
                            <div style={boldLabel}>Sex:</div>
                            <div style={boldLabel}>Smoking Status:</div>
                            <div style={boldLabel}>Occupation Rating:</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>

            <GelRowLayout gutter="medium">
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="2/3 1/3">
                            <div data-testid="fullName">{get(policyLife, 'fullName', '')}</div>
                            <div data-testid="dateOfBirth">{has(policyLife, 'dateOfBirth') ?
                                (formatDateTime(policyLife.dateOfBirth)) : ""}</div>
                        </GelColumnLayout>
                    </GelRowLayout>

                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/4 1/4 2/4">
                            <div data-testid="gender">{has(policyLife, 'gender') ? (policyLife.gender === 'M' ? 'Male' : 'Female') : ''}</div>
                            <div data-testid="smokingStatus">{has(policyLife, 'smokingStatus') ? (policyLife.smokingStatus === 'S' ? 'Smoker' : 'Non Smoker') : ''}</div>
                            <div data-testid="occupationOccupationRating">{(has(policyLife, 'occupation_OccupationRating') && policyLife.occupation_OccupationRating !== null && policyLife.occupation_OccupationRating !== '') ? policyLife.occupation_OccupationRating : 'Unknown'}</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>
        </GelRowLayout>
    );
}